const isLinkedInLink = (url) => {
  const linkedInRegex =
    /^https:\/\/(www\.)?linkedin\.com\/in\/[a-zA-Z0-9_-]+\/?$/;
  return linkedInRegex.test(url);
};

const isTwitterLink = (url) => {
  const twitterRegex = /^https:\/\/(www\.)?x\.com\/[a-zA-Z0-9_]+\/?$/;
  return twitterRegex.test(url);
};

const isGitHubLink = (url) => {
  const githubRegex = /^https:\/\/(www\.)?github\.com\/[a-zA-Z0-9_-]+\/?$/;
  return githubRegex.test(url);
};

const isMastodonLink = (url) => {
  const mastodonRegex = /^https:\/\/[a-zA-Z0-9.-]+\/@[\w.-]+\/?$/;
  return mastodonRegex.test(url);
};

const isFacebookLink = (url) => {
  const facebookRegex = /^https:\/\/(www\.)?facebook\.com\/[a-zA-Z0-9.]+\/?$/;
  return facebookRegex.test(url);
};

const isInstagramLink = (url) => {
  const instagramRegex =
    /^https:\/\/(www\.)?instagram\.com\/[a-zA-Z0-9._]+\/?$/;
  return instagramRegex.test(url);
};

const isURL = (url) => {
  const urlRegex = /^https:\/\/[^ "]+$/;
  return urlRegex.test(url);
};

const isMoocLink = (url) => {
  try {
    const parsed = new URL(url);
    return (
      (parsed.protocol === "http:" || parsed.protocol === "https:") &&
      /^([a-z0-9-]+\.)+[a-z]{2,}$/i.test(parsed.hostname)
    );
  } catch {
    return false;
  }
};

const isRepositoryLink = (url) => {
  return /^(https?:\/\/)?(www\.)?(github\.com|gitlab\.com)(\/.*)?$/i.test(url);
};

export {
  isFacebookLink,
  isGitHubLink,
  isInstagramLink,
  isLinkedInLink,
  isMastodonLink,
  isTwitterLink,
  isURL,
  isMoocLink,
  isRepositoryLink,
};
